import { Box, CircularProgress, Typography, Stack } from '@mui/material';

interface TransactionSelectionLoadingProps {
    title: string;
    description: string;
}

export default function TransactionSelectionLoading({ title, description }: TransactionSelectionLoadingProps) {
    return (
        <Box sx={{ p: 5, textAlign: 'center' }}>
            <CircularProgress size={24} sx={{ mb: 2 }} />
            <Stack spacing={1} sx={{ textAlign: 'center' }}>
                <Typography variant="h5" gutterBottom>
                    {title}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                    {description}
                </Typography>
            </Stack>
        </Box>
    );
}
